module.exports = "/call-frontend/img/bg_page_light.fd9297b3.png";